module.exports = __webpack_public_path__ + "static/img/1.b23aedd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/1.png
// module id = YXc8
// module chunks = 0